const PAGE_ID_CHARACTER_COUNTS = 18;

export const getSimilarIdFromString = (string: string) => {
  const regex = new RegExp(`\\d{${PAGE_ID_CHARACTER_COUNTS}}`, 'g');
  const [foundStringSimilarToId] = string.trim().match(regex) || ['0'];
  return foundStringSimilarToId;
};
